import {NgModule} from '@angular/core';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import * as fromUser from './reducers/company.reducer';
import {CompanyEffects} from './effects/company.effects';

@NgModule({
  declarations: [],
  imports: [
    StoreModule.forFeature(fromUser.companyFeatureKey, fromUser.reducer),
    EffectsModule.forFeature([CompanyEffects]),
  ],
})
export class CompanyStoreModule {
}
